<template>
	<div>
		<div class="account-title">
			<h1>{{ $t("companySettingsTitle") }}</h1>
			<!-- <p>Update your account management</p> -->
		</div>
		<div class="content-delivery">
			<div class="second-tabs">
				<h3>
					<img src="@/assets/images/company-icon.svg" />
					&nbsp;&nbsp;&nbsp;{{ customer.name }}
				</h3>
				<div class="grey-info">
					<b-container fluid class="border-box">
						<b-row class="border-box">
							<b-col class="border-box" xl="4" md="4">
								<p>&nbsp;</p>
								<p>
									<small>{{ $t("companyCodeLabel") }}</small>
									<br />
									<input
										disabled
										type="text"
										class="formedituser"
										v-model="customer.company_id"
									/>
								</p>
								<p>
									<small>{{ $t("deliveryAddressLabel") }}</small>
									<br />
									<input
										disabled
										type="text"
										class="formedituser"
										v-model="customer.fiscal_code"
									/>
								</p>
								<!-- <p>
                  <small>{{$t('VATLabel')}}</small>
                  <br />
                  <input disabled type="text" class="formedituser" />
                </p> -->
								<p>
									<small>{{ $t("emailField") }}</small>
									<br />
									<input
										disabled
										type="text"
										class="formedituser"
										v-model="user.email"
									/>
								</p>
							</b-col>
							<b-col class="border-box" xl="4" md="4">
								<p>&nbsp;</p>
								<p>
									<small>{{ $t("VATLabel") }}</small>
									<br />
									<input
										disabled
										type="text"
										class="formedituser"
										v-model="customer.VAT"
									/>
								</p>
								<p>
									<small>{{ $t("invoiceAddressLabel") }}</small>
									<br />
									<input
										disabled
										type="text"
										class="formedituser"
										v-model="customer.address"
									/>
								</p>
							</b-col>
						</b-row>
					</b-container>
				</div>
				<br />
			</div>
		</div>
	</div>
</template>

<script>
import Cookies from "js-cookie";
import {BContainer, BRow, BCol} from "bootstrap-vue";

export default {
	components: {
		"b-container": BContainer,
		"b-row": BRow,
		"b-col": BCol
	},
	props: {
		customer: Object,
		user: Object,
		msg: String
	},
	mounted() {
		// this.url = sessionStorage.getItem("user_link");
		this.url = Cookies.get("userLink");
		this.token = Cookies.get("token");
	},
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
